<div class="developer-wrapper">
    <div class="developer-container">
        <div class="row">
            <div class="col-md-3 col-sm-12 col-xs-12 sidebar">
                <div class="cvslogo-container">
                    <a href="#">
                        <img src="assets/logo.svg" alt="brand-logo" width="215" class="brand-logo">
                    </a> 
                </div>
                    <div class="row">
                            <ul class="nav nav-list c_affix">
                            <li class="dev-nav-title active"><a href="#overview">Overview</a></li>
                            <li class="dev-main-item"><a href="developer#intro">Introduction</a></li>
                            <li class="dev-sub-item"><a href="developer#request">Request & Response Format</a></li>
                             <li class="dev-sub-item"><a href="developer#generatetoken">Generate Access Token</a></li>
                            <li class="dev-main-item"><a href="developer#scopes">Scopes</a></li>
                            <li class="dev-main-item"><a href="developer#errorhandling">Error Handling</a></li>
                            <!-- <li class="dev-main-item"><a href="developer#ratelimit">Rate Limit</a></li>
                            <li class="dev-main-item"><a href="developer#pagination">Pagination</a></li> -->
                            <li class="dev-nav-title"><a href="developer#apiexplorer">API Explorer</a></li>
                            <li class="dev-main-item"><a href="developer#surveys">Surveys</a></li>
                            <li class="dev-sub-item"><a href="developer#create-survey">Create Authentication</a></li>
                            <li class="dev-sub-item"><a href="developer#get-survey">Get survey</a></li>
                            <!-- <li class="dev-sub-item"><a href="developer#submit-survey">Submit survey</a></li> -->
                        </ul>
                    </div>
                
            </div>
            <div class="col-sm-12 dev-api-nav">
                <a href="#">
                    <img src="assets/logo.svg" alt="brand-logo" width="215" class="brand-logo">
                </a>
            </div>
            <div class="col-md-9 col-sm-12 col-xs-12 dev-content-container">
                <section id="overview" class="dev-content-section">
                    <div class="dev-api-content">
                        <div class="c-overview-seperator initial">
                            <div class="c_hr"></div>
                            <div>
                                <h4>Overview</h4>
                            </div>
                        </div>
                    </div>
                    <div class="dev-api-code">
                </div>
                </section>
                <section id="intro" class="dev-content-section">
                    <div class="dev-api-content">
                                <h5>Introduction</h5>
                                <p> CViewSurvey  API allows you to integrate third party applications in your enterprise
                                    ecosystem and helps you to automate workflows like, sending a survey when a ticket is closed
                                    or a employee leaves the organisation.</p>
                                <h6 id="request">Request &amp; Response Format</h6>
                                <p> CViewSurvey  API accepts HTTPS requests with JSON Arguments. The response will be in JSON format. Our Authentication is based on OAuth 2.0 and you can pass your access token over Authorization header as "access token"</p>
                        </div>
                  
                    <div class="dev-api-code">
    
                    </div>
                </section>
                <!-- <section class="dev-content-section">
                    <div class="dev-api-content">
                                <h5 id="authentication">Authentication</h5>
                                <p>CViewSurvey uses OAuth 2.0 for Authentication. You can generate your access token under
                                    Settings → Apps & Integrations . You need to use the generated access token in request
                                    header as "bearer token" (-H "Authorization: Bearer Your_ACCESS_TOKEN ")</p>
                                <h6 id="generatetoken">Generate Access Token</h6>
                                <p>You can Generate Access Token using the following steps.</p>
                                <ol>
                                    <li>Login to your CViewSurvey account and go to Settings → Apps & Integrations</li>
                                    <li>Create a Private App</li>
                                    <li>Enter Name, Description, select scope and generate the access token</li>
                                    <li>Copy and keep the access token in a safe place (Access token will be displayed only once
                                        and you may need to re-generate if you misplaced)</li>
                                    <li>Save your app and you are good to start developing your private app</li>
                                </ol>
                        </div>
                  
                    <div class="dev-api-code">
    
                    </div>
                </section> -->
                <section id="scopes" class="dev-content-section">
                    <div class="dev-api-content">
                                <h5>Scopes</h5>
                                <p>While creating an app you can define the scope or privilege for the API token to communicate
                                    with your CViewSurvey account. Following are the available scopes and permissions
                                    currently supported in CViewSurvey API.</p>
                                <h6 id="request">Request &amp; Response Format</h6>
                                <table class="table table-bordered table-centered"><thead><tr><th>Scope</th><th>Permission</th></tr></thead><tbody><tr><td>View Contacts</td><td>List Contacts</td></tr><tr><td>Manage Contacts</td><td>Create Contacts, Update Contacts</td></tr><tr><td>View Contact Lists</td><td>List Contact Lists</td></tr><tr><td>Manage Contact List</td><td>Create Contact List, Update Contact List</td></tr><tr><td>View Survey</td><td>List Surveys</td></tr><tr><td>View Responses</td><td>List Responses</td></tr><tr><td>Manage Share Survey</td><td>Update Share</td></tr></tbody></table>
                        </div>
                  
                    <div class="dev-api-code">
                 </div>
                </section>
                <section id="errorhandling" class="dev-content-section">
                    <div class="dev-api-content">
                        <h5 id="authentication">Error Handling</h5>
                        <p>CViewSurvey uses standard HTTP status codes like 2xx for success and 4xx for failure. Please refer the following table for status codes.</p>
                        <!-- <table class="table table-bordered table-centered">
                            <thead><tr>
                                <th>Status Code</th><th>Permission</th></tr></thead><tbody><tr><td>200 OK</td><td>Request is successful</td></tr><tr><td>202 Accepted</td><td>Request accepted but it is queued or processing</td></tr><tr><td>400 Bad Request</td><td>Request has missing required parameters or validation errors</td></tr><tr><td>401 Unauthorized</td><td>Bad Token or missing token</td></tr><tr><td>403 Forbidden</td><td>Access denied for the requested resource</td></tr><tr><td>404 Not Found</td><td>The requested resource doesn’t exist</td></tr><tr><td>409 Conflict</td><td>Request conflicts with another, trying to create already existing resource</td></tr><tr><td>429 Too Many Requests</td><td>Api request limit exceeded</td></tr><tr><td>500 Internal Server Error</td><td>Something went wrong in CViewSurvey</td></tr><tr><td>204 No Content</td><td>Request has succeeded</td></tr></tbody></table>
                            -->
                                <table class="table table-bordered table-centered"><thead><tr><th>Status Code</th><th>Permission</th></tr></thead><tbody><tr><td>200 OK</td>
                                    <td>Request is successful</td></tr>
                                    <!-- <tr>
                                        <td>202 Accepted</td>
                                        <td>Request accepted but it is queued or processing</td></tr> -->
                                        <tr>
                                        <td>400 Bad Request</td>
                                        <td>Request has missing required parameters or validation errors</td></tr>
                                        <tr><td>401 Unauthorized</td><td>Bad Token or missing token</td></tr>
                                        <!-- <tr><td>403 Forbidden</td><td>Access denied for the requested resource</td></tr> -->
                                        <tr><td>404 Not Found</td><td>The requested resource doesn’t exist</td></tr>
                                        <!-- <tr><td>409 Conflict</td><td>Request conflicts with another, trying to create already existing resource</td></tr> -->
                                        <!-- <tr><td>429 Too Many Requests</td><td>Api request limit exceeded</td></tr> -->
                                        <tr><td>500 Internal Server Error</td><td>Something went wrong in CViewSurvey</td></tr>
                                        <!-- <tr><td>204 No Content</td><td>Request has succeeded</td></tr> -->
                                    </tbody>
                                    </table>
                                    </div>
          
            <div class="dev-api-code">
    
            </div>
                </section>
                <!-- <section id="ratelimit" class="dev-content-section">
                    <div class="dev-api-content">
                        <h5>Rate Limit</h5>
                        <p>Our API rate is limited to 120 calls per hour and 1000 requests per day. Once you exceed
                            this, API responds with an error code 429 (Too Many requests). Please get in touch with the
                            Support or Sales team for additional API requests.</p>
                        <h5 id="pagination">Pagination</h5>   
                        <p>You can use our pagination with maxResults and page parameter to navigate when your list
                            exceed our default Max-Results . Currently our default Max-Results is set at 50. When you
                            exceed this you can paginate using Page params</p>
                        <table class="table table-bordered table-centered"><thead><tr><th colspan="2" class="caption">Passed as Query Parameter</th></tr><tr class="c_long"><th>Name</th><th>Description</th></tr></thead><tbody><tr><td>maxResults</td><td>No of results needed in a request</td></tr><tr><td>page</td><td>Page No</td></tr></tbody></table>
                        <p class="c_center">For all <span>GET</span> calls you can use option params to paginate.</p>
                    </div>
                    <div class="dev-api-code">
    
                    </div>
                </section> -->
                <section id="apiexplorer" class="dev-content-section">
                    <div class="dev-api-content">
                        <div class="c-overview-seperator">
                            <div class="c_hr"></div>
                            <div><h4>API Explorer</h4></div>
                        </div>
                    </div>
                    <div class="dev-api-code">
    
                    </div>
                </section>
                <section id="create-survey" class="dev-content-section">
                    <div class="dev-api-content">
                        <h5>Surveys</h5>
                        <h6>Generate Authentication Token </h6>
                        <div class="c_method_section">
                            <span class="blue">POST</span><p>https://cviewsurvey.coworrk.com:8090/api/auth/v1/signup</p>
                        </div>
                        <table class="table table-bordered table-centered"><thead><tr><th>Name</th><th>Type</th><th>Description</th></tr></thead><tbody>
                            <tr><td>email</td> <td>string</td> <td>Email of the company</td></tr>
                            <tr><td>password</td> <td>string</td> <td>Password of the company</td></tr>
                                  <!-- <tr><td>404 Not Found</td><td>The requested resource doesn’t exist</td></tr>
                                  <tr><td>500 Internal Server Error</td><td>Something went wrong in CViewSurvey</td></tr> -->
                              </tbody>
                              </table>
  
                    </div>
                    <div class="dev-api-code dev-snippet">
                        <div class="code-content response">
                            <code>
                            <pre>
                               {{code1}}
                            </pre>                               
                            </code>
                        </div>
                    </div>
                </section>
                <section id="get-survey" class="dev-content-section">
                    <div class="dev-api-content">
                        <h6> Get All Survey</h6>
                        <div class="c_method_section">
                            <span class="blue">GET</span><p>https://cviewsurvey.coworrk.com:8090/api/v1/getallsurveys</p>
                        </div>
                        
                        <table class="table table-bordered table-centered"><thead><tr><th>header</th><th>Type</th><th>Description</th></tr></thead><tbody>
                            <tr><td>x-access-token</td> <td>(ex..  x-access-token :  eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Njk2M.)</td><td>Authentication Token generateD </td></tr>
                                  <!-- <tr><td>404 Not Found</td><td>The requested resource doesn’t exist</td></tr>
                                  <tr><td>500 Internal Server Error</td><td>Something went wrong in CViewSurvey</td></tr> -->
                              </tbody>
                              </table>
                              <br>

                        <!-- <div class="c_table"><table class="table table-bordered table-centered"><thead><tr><th colspan="6" class="caption">Other Arguments</th></tr><tr class="c_long"><th>Name</th><th>Description</th><th>Required</th><th>DataType</th><th>Default Value</th><th>Allowed values</th></tr></thead><tbody><tr><td>name</td><td>Name of the survey</td><td>Yes</td><td>String</td><td></td><td></td></tr><tr><td>surveyType</td><td>Type of the survey</td><td>Yes</td><td>String</td><td></td><td>ClassicForm</td></tr><tr><td>workspace_id</td><td>Id of the workspace</td><td>No</td><td>Number</td><td>Workspace “General” will be taken</td><td></td></tr><tr><td>theme_id</td><td>Name of the template</td><td>No</td><td>Number</td><td>Null</td><td></td></tr><tr><td>welcomeScreenYesButtonText</td><td>Welcome screen button label</td><td>No</td><td>String</td><td>Sure, ask.</td><td></td></tr><tr><td>welcomeDescriptionEnabled</td><td>It will enable welcome screen description</td><td>No</td><td>Boolean</td><td>False</td><td></td></tr><tr><td>welcomeText</td><td>Add a welcome page to the survey. Welcome screen title</td><td>No</td><td>String</td><td></td><td></td></tr><tr><td>welcomeDescription</td><td>Welcome screen description</td><td>No</td><td>String</td><td></td><td></td></tr><tr><td>thankyou_json</td><td>Add a thank you page to the survey</td><td>No</td><td>Array</td><td></td><td></td></tr></tbody></table></div> -->
                        <!-- <table class="table table-bordered table-centered"><thead><tr><th>Name</th><th>Type</th><th>Description</th></tr></thead><tbody>
                          <tr><td>companyid</td> <td>number</td> <td>ID of the company</td></tr>
                                <tr><td>404 Not Found</td><td>The requested resource doesn’t exist</td></tr>
                                <tr><td>500 Internal Server Error</td><td>Something went wrong in CViewSurvey</td></tr> 
                            </tbody>
                            </table> -->

                  
                    </div>
                    <div class="dev-api-code dev-snippet">
                        <div class="code-content response">
                            <code>
                            <pre>
                                {{code2}}
                            
                            </pre>
                              
                                    
                                                              
                            </code>
                        </div>
                        
                    </div>
                </section>
                <!-- <section id="submit-survey" class="dev-content-section">
                    <div class="dev-api-content">
                        <h6> Submit Survey</h6>
                        <div class="c_method_section">
                            <span class="blue">GET</span><p>https://api.cviewSurvey.com/v1/surveys</p>
                        </div>
                        <div class="c_table"><table class="table table-bordered table-centered"><thead><tr><th colspan="6" class="caption">Other Arguments</th></tr><tr class="c_long"><th>Name</th><th>Description</th><th>Required</th><th>DataType</th><th>Default Value</th><th>Allowed values</th></tr></thead><tbody><tr><td>name</td><td>Name of the survey</td><td>Yes</td><td>String</td><td></td><td></td></tr><tr><td>surveyType</td><td>Type of the survey</td><td>Yes</td><td>String</td><td></td><td>ClassicForm</td></tr><tr><td>workspace_id</td><td>Id of the workspace</td><td>No</td><td>Number</td><td>Workspace “General” will be taken</td><td></td></tr><tr><td>theme_id</td><td>Name of the template</td><td>No</td><td>Number</td><td>Null</td><td></td></tr><tr><td>welcomeScreenYesButtonText</td><td>Welcome screen button label</td><td>No</td><td>String</td><td>Sure, ask.</td><td></td></tr><tr><td>welcomeDescriptionEnabled</td><td>It will enable welcome screen description</td><td>No</td><td>Boolean</td><td>False</td><td></td></tr><tr><td>welcomeText</td><td>Add a welcome page to the survey. Welcome screen title</td><td>No</td><td>String</td><td></td><td></td></tr><tr><td>welcomeDescription</td><td>Welcome screen description</td><td>No</td><td>String</td><td></td><td></td></tr><tr><td>thankyou_json</td><td>Add a thank you page to the survey</td><td>No</td><td>Array</td><td></td><td></td></tr></tbody></table></div>
                    </div>
                    <div class="dev-api-code dev-snippet">
                        <div class="code-content response">
                            <code>
                            <pre>
                                {{code3}}
                            
                            </pre>
                                    
                            </code>
                          
                        </div>

                    </div>
                </section> -->
            </div>
        </div>
    </div>
</div>

